import React, { createContext, useState, useContext } from 'react';

// Criar o contexto de autenticação
const AuthContext = createContext();

// Provedor de autenticação
export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [brotherName, setBrotherName] = useState(''); // Estado para armazenar o nome

    // Função de login que define o estado autenticado e o nome 
    const login = (username) => {
        setIsAuthenticated(true);
        setBrotherName(username); // Define o nome logado
    };

     

    return (
        <AuthContext.Provider value={{ isAuthenticated, brotherName, login }}>
            {children}
        </AuthContext.Provider>
    );
};

// Hook para usar o contexto de autenticação
export const useAuth = () => {
    return useContext(AuthContext);
};